var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"horizontal-separator"},[_vm._t("default",function(){return [_vm._v("OR")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }